import React, { useState, useEffect } from "react";
import { Box, Button, Spinner, useMediaQuery } from "@chakra-ui/react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useToast,
} from "@chakra-ui/react";
import { RepeatIcon } from "@chakra-ui/icons";
import axios from "axios";

import GLTableauMIX from "../../../Components/EmbedGL/GLTableauMIX";
import GLTableauHourly from "../../../Components/EmbedGL/GLTableauHourly";
import GLTableauWeekly from "../../../Components/EmbedGL/GLTableauWeekly";
import GLTableauTender from "../../../Components/EmbedGL/GLTableauTender";
import GLTableauChannel from "../../../Components/EmbedGL/GLTableauChannel";
import GLTableauDSR from "../../../Components/EmbedGL/GLTableauDSR";
import GLTableauNPS from "../../../Components/EmbedGL/GLTableauNPS";

import GLTableauMIXM from "../../../Components/EmbedGL/MobileView/GLTableauMIXM";
import GLTableauHourlyM from "../../../Components/EmbedGL/MobileView/GLTableauHourlyM";
import GLTableauWeeklyM from "../../../Components/EmbedGL/MobileView/GLTableauWeeklyM";
import GLTableauTenderM from "../../../Components/EmbedGL/MobileView/GLTableauTenderM";
import GLTableauChannelM from "../../../Components/EmbedGL/MobileView/GLTableauChannelM";
import GLTableauDSRM from "../../../Components/EmbedGL/MobileView/GLTableauDSRM";
import GLTableauNPSM from "../../../Components/EmbedGL/MobileView/GLTableauNPSM";

const GLReports = ({ content }) => {
  const [isSmallerThan600] = useMediaQuery("(max-width: 600px)");
  const [refreshPage, setRefreshPage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [key, setKey] = useState(Date.now());
  const toast = useToast();

  const handleRefreshTokenTableauButton = async () => {
    try {
      setLoading(true);
      const resJWTTableau = await axios.get(
        `${process.env.REACT_APP_BACKEND_API_URL}/generatejwt`,
        { withCredentials: true },
      );
      localStorage.setItem("tableauToken", resJWTTableau.data);
      setRefreshPage((prev) => !prev);
      setKey(Date.now());
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast({
        title: "Error",
        position: "top-right",
        description: err.response?.data?.message || "Failed to refresh token.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setFirstLoad(false);
    }, 1000 * 3);

    return () => clearTimeout(timer);
  }, [refreshPage]);

  return (
    <>
      <div key={key}>
        <Box mt={4} mb={2}>
          <Button
            colorScheme="orange"
            onClick={handleRefreshTokenTableauButton}
            isDisabled={loading}
          >
            {loading ? (
              <Spinner />
            ) : (
              <>
                Refresh <RepeatIcon marginLeft={2} />
              </>
            )}
          </Button>
        </Box>
        <Tabs isFitted variant="enclosed">
          <TabList
            mb="1em"
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            <Tab _selected={{ color: "white", bg: "orange.500" }}>Product Mix</Tab>
            <Tab _selected={{ color: "white", bg: "orange.500" }}>Hourly</Tab>
            <Tab _selected={{ color: "white", bg: "orange.500" }}>Weekly</Tab>
            <Tab _selected={{ color: "white", bg: "orange.500" }}>Tender</Tab>
            <Tab _selected={{ color: "white", bg: "orange.500" }}>Channel</Tab>
            <Tab _selected={{ color: "white", bg: "orange.500" }}>DSR</Tab>
            <Tab _selected={{ color: "white", bg: "orange.500" }}>NPS</Tab>
          </TabList>
          <TabPanels
            height={{
              base: "100%",
              md: "50%",
              xl: "25%",
            }}
            width="100%"
            m={0}
            p={0}
          >
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <GLTableauMIXM />
              ) : (
                <GLTableauMIX />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <GLTableauHourlyM />
              ) : (
                <GLTableauHourly />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <GLTableauWeeklyM />
              ) : (
                <GLTableauWeekly />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <GLTableauTenderM />
              ) : (
                <GLTableauTender />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <GLTableauChannelM />
              ) : (
                <GLTableauChannel />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <GLTableauDSRM />
              ) : (
                <GLTableauDSR />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <GLTableauNPSM />
              ) : (
                <GLTableauNPS />
              )}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </>
  );
};

export default GLReports;
